import type { TranslationTag } from '@ps/web-core-intl';
import { Translation } from '@ps/web-shared-components';
import type { ClassNameProp, ValuesProp } from '@ps/web-shared-components';
import React from 'react';
import { useField } from 'react-final-form';

import type { ErrorsProp, FieldNameProp } from '@swf/core/types/Props';

import ValidationMessage from '../ValidationMessage/ValidationMessage';

import { staticText } from './FieldValidationMessage.scss';

export interface Text extends Partial<ValuesProp> {
  translation: TranslationTag;
}

type Props = FieldNameProp &
  Partial<ErrorsProp> &
  Partial<ClassNameProp> & {
    staticMessage?: Text;
  };

const FieldValidationMessage: React.FC<Props> = ({
  errors,
  fieldName,
  className,
  staticMessage
}) => {
  const {
    meta: { touched, invalid }
  } = useField(fieldName);

  const error = errors?.find(({ valid }) => valid === false);

  return touched && invalid ? (
    <ValidationMessage
      touched={touched}
      invalid={invalid}
      className={className}
      message={error?.message}
    />
  ) : staticMessage ? (
    <div className={staticText}>
      <Translation {...staticMessage.translation} values={staticMessage.values} />
    </div>
  ) : null;
};

export default FieldValidationMessage;
